export default __webpack_public_path__ + "static/media/cross-light.d180fc63.svg";